import DDMultiple, { Option } from "../../../components/Atomos/DropDown/DDMultiple";
import LegacyButton from "../../../components/Atomos/Buttons/LegacyButton";

interface MemberEventsContactEditProps {
  professionals: Option[];
  selectedProfessionals: Option[];
  wsgContacts: Option[];
  selectedWSGContacts: Option[];
  onProfessionalsChange: (professionals: any) => void;
  onWSGContactsChange: (contacts: any) => void;
  onSave: () => void;
}

export default function MemberEventsContactEdit({
  professionals,
  selectedProfessionals,
  wsgContacts,
  selectedWSGContacts,
  onProfessionalsChange,
  onWSGContactsChange,
  onSave,
}: MemberEventsContactEditProps) {
  return (
    <div className="bg-[#F6F6F6] pb-4 min-h-[500px]">
      <p className="text-start font-Roboto text-[#474F56] font-[400] text-lg ml-5 pt-4">
        Contacts
      </p>
      <div className="h-px bg-primary w-[200px] mb-4"></div>
      <div className="flex flex-col gap-4 mx-5">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <div className="w-full md:w-1/2">
            <p className="text-start font-Roboto text-[#474F56] font-[400] text-base mb-2">
              Professionals
            </p>
            <DDMultiple
              title=""
              objects={professionals}
              selectedObjst={selectedProfessionals}
              seter={(e) => onProfessionalsChange(e)}
              ddclass="w-full"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <div className="w-full md:w-1/2">
            <p className="text-start font-Roboto text-[#474F56] font-[400] text-base mb-2">
              WSG Contacts
            </p>
            <DDMultiple
              title=""
              objects={wsgContacts}
              selectedObjst={selectedWSGContacts}
              seter={(e) => onWSGContactsChange(e)}
              ddclass="w-full"
            />
          </div>
        </div>
        <div className="flex justify-end mt-4">
          <LegacyButton
            text="Save"
            onClick={onSave}
            className="w-full md:w-1/3"
          />
        </div>
      </div>
    </div>
  );
}

